var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkill3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7937_6288)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7937_6288",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 90
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 0H0V90H90V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7937_6288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0252 71.6988H46.9751C49.1565 71.6988 50.9248 73.4671 50.9248 75.6485V76.9699C50.9248 77.3324 50.6532 77.6374 50.293 77.6789L48.9108 77.8388C48.5332 77.8825 48.1638 77.979 47.813 78.1257C46.0089 78.8799 43.9781 78.8821 42.1723 78.1315L42.1628 78.1277C41.7967 77.9756 41.4113 77.8751 41.0175 77.8298L39.7074 77.6788C39.3472 77.6372 39.0754 77.3323 39.0754 76.9697V75.6485C39.0754 73.4671 40.8438 71.6988 43.0252 71.6988Z",
    stroke: "#00A0AE",
    strokeWidth: 2.1672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9078 60.3331H45.0925C46.6977 60.3331 47.9833 61.664 47.9275 63.2683L47.8351 65.9228C47.782 67.4501 46.5283 68.6609 45.0001 68.6609C43.4719 68.6609 42.2182 67.4501 42.1651 65.9228L42.0728 63.2683C42.017 61.664 43.3026 60.3331 44.9078 60.3331Z",
    stroke: "#00A0AE",
    strokeWidth: 2.1672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.961 47.0059H74.9109C77.0923 47.0059 78.8606 48.7742 78.8606 50.9556V52.277C78.8606 52.6395 78.589 52.9444 78.2288 52.986L76.8466 53.1458C76.469 53.1896 76.0996 53.2861 75.7488 53.4328C73.9447 54.187 71.9139 54.1891 70.1081 53.4385L70.0986 53.4347C69.7325 53.2826 69.3471 53.1822 68.9533 53.1368L67.6432 52.9858C67.283 52.9442 67.0112 52.6393 67.0112 52.2768V50.9556C67.0112 48.7742 68.7796 47.0059 70.961 47.0059Z",
    stroke: "#00A0AE",
    strokeWidth: 2.1672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8436 35.64H73.0283C74.6335 35.64 75.9191 36.9709 75.8633 38.5752L75.7709 41.2297C75.7178 42.757 74.4641 43.9678 72.9359 43.9678C71.4077 43.9678 70.154 42.757 70.1009 41.2297L70.0086 38.5752C69.9528 36.9709 71.2383 35.64 72.8436 35.64Z",
    stroke: "#00A0AE",
    strokeWidth: 2.1672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.115 22.3201H47.0649C49.2464 22.3201 51.0147 24.0884 51.0147 26.2699V27.5912C51.0147 27.9538 50.7431 28.2587 50.3829 28.3003L49.0007 28.4601C48.623 28.5038 48.2537 28.6003 47.9028 28.747C46.0987 29.5012 44.0679 29.5034 42.2622 28.7528L42.2526 28.749C41.8865 28.5969 41.5011 28.4965 41.1073 28.4511L39.7973 28.3001C39.4371 28.2585 39.1653 27.9536 39.1653 27.5911V26.2699C39.1653 24.0884 40.9336 22.3201 43.115 22.3201Z",
    stroke: "#00A0AE",
    strokeWidth: 2.1672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9976 10.9542H45.1823C46.7876 10.9542 48.0731 12.2851 48.0173 13.8895L47.925 16.5439C47.8719 18.0712 46.6182 19.2821 45.09 19.2821C43.5618 19.2821 42.3081 18.0712 42.255 16.5439L42.1626 13.8895C42.1068 12.2851 43.3924 10.9542 44.9976 10.9542Z",
    stroke: "#00A0AE",
    strokeWidth: 2.1672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3452 47.0059H19.2952C21.4766 47.0059 23.2449 48.7742 23.2449 50.9556V52.277C23.2449 52.6395 22.9733 52.9444 22.6131 52.986L21.2309 53.1458C20.8532 53.1896 20.4839 53.2861 20.1331 53.4328C18.3289 54.187 16.2982 54.1891 14.4924 53.4385L14.4829 53.4347C14.1167 53.2826 13.7314 53.1822 13.3375 53.1368L12.0275 52.9858C11.6673 52.9442 11.3955 52.6393 11.3955 52.2768V50.9556C11.3955 48.7742 13.1638 47.0059 15.3452 47.0059Z",
    stroke: "#00A0AE",
    strokeWidth: 2.1672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2279 35.64H17.4125C19.0178 35.64 20.3033 36.9709 20.2475 38.5752L20.1552 41.2297C20.1021 42.757 18.8484 43.9678 17.3202 43.9678C15.792 43.9678 14.5383 42.757 14.4852 41.2297L14.3929 38.5752C14.3371 36.9709 15.6226 35.64 17.2279 35.64Z",
    stroke: "#00A0AE",
    strokeWidth: 2.1672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8269 47.9897V50.8652H48.173V47.9897C49.4848 46.7774 51.4236 44.2688 51.4897 41.3386C51.5723 37.6745 48.4424 34.7511 44.9605 34.7974C41.4772 34.8436 38.4371 37.6622 38.4202 41.3272C38.4074 44.0774 40.5151 46.7774 41.8269 47.9897Z",
    stroke: "#EEE82C",
    strokeWidth: 2.1672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8247 50.8652H48.1751V52.4251C48.1751 53.6263 47.2015 54.5999 46.0003 54.5999H43.9995C42.7983 54.5999 41.8247 53.6263 41.8247 52.4251V50.8652Z",
    stroke: "#EEE82C",
    strokeWidth: 2.1672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.47 30.106C67.0131 24.5325 61.7183 20.2184 55.4321 18.0104",
    stroke: "#EEE82C",
    strokeWidth: 2.1672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5298 30.106C22.9867 24.5325 28.2816 20.2184 34.5677 18.0104",
    stroke: "#EEE82C",
    strokeWidth: 2.1672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.47 59.8892C67.0131 65.4627 61.7183 69.7768 55.4321 71.9849",
    stroke: "#EEE82C",
    strokeWidth: 2.1672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5298 59.8892C22.9867 65.4627 28.2816 69.7768 34.5677 71.9849",
    stroke: "#EEE82C",
    strokeWidth: 2.1672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7937_6288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill3);
export default __webpack_public_path__ + "static/media/skill3.953fd46107659f49d170c0f857977d64.svg";
export { ForwardRef as ReactComponent };